import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import GenericIcons from '../../components/generics/GenericIcons';
import { useLocation, useNavigate } from 'react-router-dom';
import * as AboutUspages from './AboutUsPages';
import '../../css/PublicAboutUsPage.css';

export enum btnKey {
  nosotros = 'visionderred',
  mision = 'mision-y-vision',
  valores = 'nuestros-valores',
  equipo = 'nuestro-equipo-y-partners',
  historia = 'historia-y-origen-de-visionderred',
  impacto = 'impacto-en-el-sector-y-logros',
  compromiso = 'compromiso-con-la-innovacion-y-el-futuro',
  llamado = 'llamado-a-la-accion'
}

const PublicAboutUsPage: FunctionComponent = () => {
  const aboutUsDoBtns: Array<{
    key: btnKey;
    name: string;
    icon: string;
    component: JSX.Element;
  }> = useMemo(
    () => [
      {
        key: btnKey.nosotros,
        name: 'VisiónDERRED',
        icon: '',
        component: <AboutUspages.Component01 />
      },
      {
        key: btnKey.mision,
        name: 'Misión y Visión',
        icon: 'eyeIdeaIcon',
        component: <AboutUspages.Component02 />
      },
      {
        key: btnKey.valores,
        name: 'Nuestros Valores',
        icon: 'loveIiHandGiveIcon',
        component: <AboutUspages.Component03 />
      },
      {
        key: btnKey.equipo,
        name: 'Nuestro Equipo y Colaboradores',
        icon: 'multipleUsersIcon',
        component: <AboutUspages.Component04 />
      },
      {
        key: btnKey.historia,
        name: 'Historia y Origen de VisiónDERRED',
        icon: 'readGlassesIcon',
        component: <AboutUspages.Component05 />
      },
      {
        key: btnKey.impacto,
        name: 'Impacto en el Sector y Logros',
        icon: 'rankingRibbonIcon',
        component: <AboutUspages.Component06 />
      },
      {
        key: btnKey.compromiso,
        name: 'Compromiso con la Innovación y el Futuro',
        icon: 'businessDealHandshakeCircleIcon',
        component: <AboutUspages.Component07 />
      },
      {
        key: btnKey.llamado,
        name: 'Llamado a la Acción',
        icon: 'teamIdeaIcon',
        component: <AboutUspages.Component08 />
      }
    ],
    []
  );

  const navigate = useNavigate();
  const location = useLocation();
  const [aboutUsBtnActive, setAboutUsBtnActive] = useState<btnKey>(btnKey.nosotros);

  const optionParam = useMemo(() => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(location.search);
    const option = params.get('option');
    return option;
  }, [location.search]);

  useEffect(() => {
    const findBtn = aboutUsDoBtns.find((btn) => btn.key === optionParam);
    if (findBtn) {
      setAboutUsBtnActive(findBtn.key);
    } else {
      setAboutUsBtnActive(btnKey.nosotros);
    }
  }, [aboutUsDoBtns, optionParam]);

  return (
    <div className='public-about-us-page-container vdr-about'>
      <header className='vdr-about-hero'>
        <div className='vdr-about-hero-inner'>
          <span className='vdr-eyebrow vdr-eyebrow--bar vdr-eyebrow--on-dark'>Nosotros</span>
          <h1 className='public-about-us-page-side-bar-title vdr-about-hero-title'>
            Quiénes somos
          </h1>
        </div>
      </header>
      <div className='vdr-about-body'>
        <div className='public-about-us-page-side-bar vdr-about-nav'>
          <span className='vdr-eyebrow vdr-about-nav-label' aria-hidden='true'>
            Secciones
          </span>
          <div className='public-about-us-page-side-bar-buttons-container vdr-about-nav-list'>
            {aboutUsDoBtns.map((btn, idx) => (
              <button
                key={`public-home-page-about-us-btn-key-${idx}`}
                className={`interactive-button vdr-about-nav-item ${
                  btn.key === aboutUsBtnActive ? 'interactive-button-active' : ''
                }`}
                onClick={() => navigate(`/public/quienes-somos?option=${btn.key}`)}>
                <GenericIcons icon={btn.icon} imageStyle={{ height: '2vw' }} />
                <span className='vdr-about-nav-name'>{btn.name}</span>
              </button>
            ))}
          </div>
        </div>
        <div className='public-about-us-page-content vdr-about-content'>
          {aboutUsDoBtns.find((btn) => btn.key === aboutUsBtnActive)?.component}
        </div>
      </div>
    </div>
  );
};

export default PublicAboutUsPage;
